import { fade } from '@material-ui/core/styles/colorManipulator';
export const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto"
  },
  table: {
    minWidth: 700
  },
  button: {
    margin: '1.5rem',
    float: 'right'
  },
  iconTrashActive: {
    color: '#ff513f'
  },
  iconTrashNotActive: {
    color: '#d0d0d0'
  },
  icon: {
    fontSize: 40,
    float: 'right',
    cursor: 'pointer',
  },
  iconWrap: {
    fontSize: 40,
    float: 'right',
    cursor: 'pointer',
    padding: '4px'
  },
  customInput: {
    textAlign: 'left'
  },
  customRoot: {
    
  },
  customInputValue: {
    textAlign: 'right'
  },
  textField: {
    textAlign: 'left',
  },
  titlePickDate: {
    display: 'flex',
    justifyContent : 'space-between',
    padding: '1rem'
  },
  // search: {
  //   position: 'relative',
  //   borderRadius: theme.shape.borderRadius,
  //   // backgroundColor: fade('#9E9E9E', 0.15),
  //   '&:hover': {
  //     backgroundColor: 'rgba(255, 255, 255, 0.8)',
  //   },
  //   marginRight: theme.spacing(2),
  //   marginLeft: 0,
  //   width: '100%',
  //   [theme.breakpoints.up('sm')]: {
  //     marginLeft: theme.spacing(3),
  //     width: 'auto',
  //   },
  //   backgroundColor: 'rgba(255, 255, 255, 0.8)',
  //   display: 'flex',
  //   // backgroundColor: '#eaeaea'
  // },
  // searchIcon: {
  //   width: theme.spacing(9),
  //   height: '100%',
  //   position: 'absolute',
  //   pointerEvents: 'none',
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  // },
  // inputRoot: {
  //   color: 'inherit',
  //   width: '100%',
  // },
  // inputInput: {
  //   paddingTop: theme.spacing(1),
  //   paddingRight: theme.spacing(1),
  //   paddingBottom: theme.spacing(1),
  //   paddingLeft: theme.spacing(10),
  //   transition: theme.transitions.create('width'),
  //   width: '100%',
  //   [theme.breakpoints.up('sm')]: {
  //     width: 120,
  //     '&:focus': {
  //       width: 200,
  //     },
  //   },
  // },
  frameTitle: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  iconEdit : {
    width: '16px',
    height: '16px',
    cursor: 'pointer',
  }
});
export const styleSalaryEmployee = theme => ({
  title: {
        // color: #000000;
    padding: 0,
    fontSize: '1.5rem',
    textAlign: 'center', 
    fontWeight: '500',
    lineHeight: 'normal',
  },
  iconTrashActive: {
    color: '#ff513f',
    // height: '1rem'
  },
  DialogTitle: {
     padding: '1.5rem' 
  },
  root : {
    fontSize: '1rem',
  },
  customHead : {
    fontSize: '0.875rem',
    color: '#546e7a',
    padding: '14px 40px 14px 16px'
  },
  customLastRow : {
    paddingTop: '1.5rem',
    paddingBottom: '1.5rem',
    padding: '14px 40px 14px 16px'
  },
  DialogContent: {
      padding: '0rem', 
  },
  customCell: {
      padding: '14px 40px 14px 16px'
  },
});